import Layout from './layout.vue'
import Header from './header.vue'
import Sider from './sider.vue'
import Content from './content.vue'
import Footer from './footer.vue'

Layout.Header = Header
Layout.Sider = Sider
Layout.Content = Content
Layout.Footer = Footer

export default Layout
